import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';

const Span = styled.span``;

const RawHtml = ({ children, ...props }) =>
  <Span dangerouslySetInnerHTML={{ __html: sanitizeHtml(children) }} {...props}/>;

export default RawHtml;
